// import { useState, useEffect, useRef } from 'react';
// import { ReactSVG } from 'react-svg';
// import Image from 'next/image';
// import classNames from 'classnames';
// import { Button } from '@forma/forma-ui-kit';
import PageBlock, { DemoButtons } from '@/components/PageBlock';
import Video from '@/components/Video';
import analytics from '@/helpers/analytics';

import styles from './main-banner-2.module.css';
import { ReactSVG } from 'react-svg';

const MainBanner2 = ({ title, description, variant }) => {
  // const overlayRef = useRef(null);
  // const intervalRef = useRef(null);
  // const { t } = useTranslation();
  // const { viewport } = useTheme();
  // const [openVideo, setOpenVideo] = useState(false);

  // const [isAnimated] = useState(true);
  // const [activeButton, setActiveButton] = useState(0);

  // const [imagePosition, setImagePosition] = useState({ x: 0, y: 0, visible: false });

  // useEffect(() => {
  //   if (!isAnimated || !main?.solutions?.length) return;

  //   let index = 0;

  //   const animateOnce = () => {
  //     if (index < main.solutions.length) {
  //       setActiveButton(index);
  //       intervalRef.current = setTimeout(() => {
  //         index++;
  //         animateOnce();
  //       }, 250);
  //     } else {
  //       setActiveButton(999);
  //     }
  //   };

  //   animateOnce();

  //   return () => {
  //     if (intervalRef.current) {
  //       clearTimeout(intervalRef.current);
  //       intervalRef.current = null;
  //     }
  //   };
  // }, [isAnimated, main?.solutions]);

  // const handleMouseMove = (e) => {
  //   setImagePosition({ x: e.clientX, y: e.clientY, visible: true });
  // };

  // const handleMouseLeave = () => {
  //   setImagePosition(prev => ({ ...prev, visible: false }));
  // };

  // useEffect(() => {
  //   const overlay = overlayRef.current;
  //   overlay?.addEventListener('mousemove', handleMouseMove);
  //   overlay?.addEventListener('mouseleave', handleMouseLeave);
  //   overlay?.addEventListener('mousecancel', handleMouseLeave);

  //   return () => {
  //     overlay?.removeEventListener('mousemove', handleMouseMove);
  //     overlay?.removeEventListener('mouseleave', handleMouseLeave);
  //     overlay?.removeEventListener('mousecancel', handleMouseLeave);
  //   };
  // }, [overlayRef.current]);

  return (
    <PageBlock className={styles.root} variant={variant}>
      <div className={styles.requestCall}>
        <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
        {/* <p className={styles.subtitle}>{description}</p>*/}
        {/* <ButtonsContainer className={styles.topButtons}>
          {main?.solutions.map(({ name, href, icon }, index) => (
            <Button
              as={Link}
              viewStyle="secondary"
              className={classNames(
                styles.button,
                styles.secondary,
                styles.topButton,
                activeButton === index && styles.active
              )}
              // onMouseEnter={() => { setAnimated(false); setActiveButton(index); }}
              // onMouseLeave={() => setAnimated(true)}
              // onClick={() => {
              //   analytics.clickTryTrial();
              // }}
              href={href}
              icon={<ReactSVG src={icon} wrapper="span" />}
              key={name}
            >
              {name}
            </Button>
          ))}
        </ButtonsContainer>*/}
      </div>
      <Video
        src="https://static.forma.today/videos/main_new.mp4"
        className={styles.videoEmbed}
      />
      {/* <div className={styles.videoWrap}>
        {openVideo ? (
          <Video
            className={styles.video}
            src="https://static.forma.today/videos/service.mp4"
            autoPlay
          />
        ) : (
          <Image
            className={styles.fillingScreen}
            src="/images/screen-filling-2.webp"
            alt="Заполнение шаблона"
            width={1146}
            height={577}
          />
        )}
        {!openVideo && (
          <div className={styles.videoOverlay} onClick={() => setOpenVideo(true)} ref={overlayRef}>
            <Button
              className={classNames(styles.playButton)}
              // onClick={() => setOpenVideo(true)}
              iconClassName={styles.playIcon}
              icon={<ReactSVG src="/icons/play-3.svg" />}
              onClick={() => analytics.trackYandex('main_scroll1_video_play')}
            />
            <div
              className={classNames(styles.playText, imagePosition.visible && styles.visible)}
              style={{ position: 'fixed', top: imagePosition.y, left: imagePosition.x, pointerEvents: 'none' }}
            >
              <img
                src="/images/play-button-text.svg"
                alt="Посмотрите, как работает DataDoc"
                width={200}
                height={81}
              />
            </div>
          </div>
        )}
      </div>*/}
      <DemoButtons
        buttonsClassName={styles.buttons}
        startButton={{
          icon: <ReactSVG src="/icons/chevron-right-small.svg" />,
          onClick: () => analytics.trackYandex('main_scroll1_free_start')
        }}
        demoButton={{
          onClick: () => analytics.trackYandex('main_scroll1_demo_request'),
        }}
        noticeClassName={styles.notice}
      />

      {/* <ClientWrap>
        <Modal
          open={openVideo}
          onClose={() => setOpenVideo(false)}
          width="1024px"
        >
          <Video
            className={styles.video}
            src="https://static.forma.today/videos/Forma-Anim_1920-1080_All_5-9_H264.mp4"
          />
        </Modal>
      </ClientWrap> */}
    </PageBlock>
  );
};

export default MainBanner2;
